import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b8cd100"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid-container" }
const _hoisted_2 = { class: "ui-small" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Date Picker", -1))
const _hoisted_4 = {
  key: 0,
  class: "stats"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Statistics", -1))
const _hoisted_6 = {
  key: 1,
  class: "timeMachine"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Time Machine", -1))
const _hoisted_8 = {
  key: 0,
  class: "content"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Data points:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dateManager = _resolveComponent("dateManager")!
  const _component_statistics = _resolveComponent("statistics")!
  const _component_time_machine = _resolveComponent("time-machine")!
  const _component_coin_history = _resolveComponent("coin-history")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_dateManager, { onDates: _ctx.dateChanged }, null, 8, ["onDates"])
      ]),
      (_ctx.historyLoaded == true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            (_ctx.historyLoaded == true)
              ? (_openBlock(), _createBlock(_component_statistics, {
                  key: 0,
                  history: _ctx.history
                }, null, 8, ["history"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.historyLoaded == true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_time_machine, {
              Prices: _ctx.history.prices
            }, null, 8, ["Prices"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.historyLoaded == true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_coin_history, {
            Prices: _ctx.history.prices
          }, null, 8, ["Prices"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}